// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mj-0";
export var assigneeDetails = "_mj-1";
export var assigneeInfo = "_mj-2";
export var dropdownContainer = "_mj-4";
export var dropdownImage = "_mj-5";
export var editAssigneeInfo = "_mj-3";
export var editAssigneeModalContainer = "_mj-6";
export var hidden = "_mj-8";
export var input = "_mj-7";